import { createFileRoute } from '@tanstack/react-router';
import { AuditLogPage } from '../../../features/audit/pages/AuditLogPage';
import { usePageTitle } from '../../../lib/hooks.js';

function RouteComponent() {
  usePageTitle('Audit Logs');
  return <AuditLogPage />;
}

export const Route = createFileRoute("/_auth/audit/")({
  component: RouteComponent,
});
